import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'padNumber'
})
export class PadNumberPipe implements PipeTransform {
  public transform(value: number, numberOfCharacters: number = 2): string {
    let paddedNumber: string = value.toString();
    while (paddedNumber.length < numberOfCharacters) {
      paddedNumber = '0' + paddedNumber;
    }
    return paddedNumber;
  }
}
